import IFormsService from './IFormsService'
import {AxiosResponse} from 'axios'
import {SiteNominationPostBody} from './interfaces'
import {Client} from "@apps/Shared/Services/Axios";
import i18n from "i18next";
import {ENDPOINT} from "@apps/Shared/Services/Axios/Api";
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";

class FormsService implements IFormsService {
    async SiteNomination(postBody: SiteNominationPostBody) {
        const valuesToSend = new FormData()
        for (const key in postBody) {
            valuesToSend.append(key, postBody[key])
        }

        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.SiteNominations.PostForm()}`, valuesToSend);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetSiteNominationLeaderboard() {
        let res: AxiosResponse;

        try {
            res = await Client('get', ENDPOINT.SiteNominations.Leaderboard());
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new FormsService();